import { render, staticRenderFns } from "./AreaManagersPageEdit.vue?vue&type=template&id=24450a24&"
import script from "./AreaManagersPageEdit.vue?vue&type=script&lang=ts&"
export * from "./AreaManagersPageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24450a24')) {
      api.createRecord('24450a24', component.options)
    } else {
      api.reload('24450a24', component.options)
    }
    module.hot.accept("./AreaManagersPageEdit.vue?vue&type=template&id=24450a24&", function () {
      api.rerender('24450a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/AreaManagers/AreaManagersPageEdit.vue"
export default component.exports